const addressSubscriptionData = {
  streetName: null,
  streetNumber: null,
  label: null,
  city: null,
  inseeCode: null,
  cityId: null,
  province: null,
  zipcode: null,
  housingType: null,
  floor: null,
  staircase: null,
  tenantType: null,
  residenceType: null,
  apartmentNumber: null,
  additionalInformation: null,
  isResident: null,
  surface: null,
  heatingEnergy: null,
  hotwaterEnergy: null,
  cookingEnergy: null,
  electricityMeter: {},
  gasMeter: {},
  hasElectricityMeter: false,
  hasGasMeter: false,
}

export default addressSubscriptionData
